<script>
import Location from "@/components/modals/property-location.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Stocks from "@/components/modals/stocks.vue";
export default {
    name: "RequisitionModal",
    components: {
        Location,
        Employee,
        Stocks
    },
    props: {
        modalTitle: {
            type: String,
            default: "Create Requisition",
        },
        from: {
            type: String,
            default: "supply",
        },
    },
    data() {
        return {
            form: [],
            currentPageForm: 1,
            setAllEmployee: false,
            setAllLocation: false,
            submitted: false,
            selectedIar: null,
            isUpdate: false,
            generateRIS: true,
            requisitionNumber: '',
            addToStock: false,
            setAllStock: false,
        };
    },
    computed: {
        filteredForm() {
            if (this.form && this.form.length) {
                const start = (this.currentPageForm - 1);
                const end = start + 1;
                return this.form.slice(start, end);
            }
            return [];
        },
        buttonText() {
            if(this.isUpdate) return 'Update';
            if(this.from === 'office') return 'Create as Draft';
            return 'Create Requisition';
        },
    },
    methods: {
        onCreate() {
            this.submitted = true;
            if(this.checkForm()) return;
            let data = {
                form: this.form.map(item => {
                    item.quantity = this.getExactAmt(item.quantity);
                    return item;
                }),
                isUpdate: this.isUpdate,
                requisitionNumber: this.requisitionNumber,
            }
            this.$emit("submit", data);
        },
        checkForm() {
            let errors = 0;
            let indexErrors = [];
            this.form.forEach((item, index) => {
                if (
                    item.endUserId == "" || 
                    (this.from === 'office' && item.propertyLocationId == "") || 
                    item.quantity == 0 || 
                    item.quantity > item.maxQuantity ||
                    (this.addToStock && (item.stockItemId == "" || item.stockItemId == null))
                ) {
                    errors++;
                    indexErrors.push(index + 1);
                }
            });
            if (errors > 0) {
                this.showToast(`Some fields in item/s ${indexErrors.join(", ")} needs to be filled.`, "error");
                return true;
            }
            return false;
        },
        getEmployee(iarItemId, name) {
            if(name && this.from === 'supply'){
                var filter = null;
                if(name && name.includes(",")){
                    filter = name.substring(0, name.indexOf(","));
                }
                if(name && name.includes(" ")){
                    let split = name.split(" ");
                    filter = split[split.length - 1];
                }
                this.$refs.employee.resetData(filter);
            }else{
                this.$refs.employee.resetData();
            }
            this.selectedIar = iarItemId;
            this.$bvModal.show("externalEmployee-modal");
        },
        dropEmployee(data) {
            if (this.setAllEmployee) {
                this.form.forEach((item) => {
                    item.endUserId = data.idNo;
                    item.employeeName = data.firstName.concat(" ", data.lastName);
                });
            } else {
                var index = this.form.findIndex((item) => item.iarItemId == this.selectedIar);
                this.form[index].endUserId = data.idNo;
                this.form[index].employeeName = data.firstName.concat(" ", data.lastName);
                this.form[index].firstName = data.firstName;
                this.form[index].middleName = data.middleName;
                this.form[index].lastName = data.lastName;
            }
        },
        assignToAllEmployee(item) {
            if (this.setAllEmployee) {
                for (const i of this.form) {
                    i.endUserId = item.endUserId;
                    i.employeeName = item.employeeName;
                }
            } else {
                for (const i of this.form) {
                    if(i.iarItemId == item.iarItemId) continue;
                    i.endUserId = null;
                    i.employeeName = "";
                }
            }
        },
        getLocation(iarItemId) {
            this.selectedIar = iarItemId;
            this.$bvModal.show("location-modal");
            this.$refs.location.getData(this.$store.state.data.selectedCampus.id);
        },
        dropLocation(data) {
            if (this.setAllLocation) {
                this.form.forEach((item) => {
                    item.propertyLocationId = data.location.id;
                    item.location = data.location.location;
                });
            } else {
                var index = this.form.findIndex((item) => item.iarItemId == this.selectedIar);
                this.form[index].propertyLocationId = data.location.id;
                this.form[index].location = data.location.location;
            }
        },
        assignToAllLocation(item, event) {
            if (event.target.checked) {
                for (const i of this.form) {
                    i.propertyLocationId = item.propertyLocationId;
                    i.location = item.location;
                }
            } else {
                for (const i of this.form) {
                    if(i.iarItemId == item.iarItemId) continue;
                    i.propertyLocationId = null;
                    i.location = "";
                }
            }
        },
        assignToAllStock(item, event) {
            if (event.target.checked) {
                for (const i of this.form) {
                    i.stockItemId = item.stockItemId;
                    i.stockName = item.stockName;
                }
            } else {
                for (const i of this.form) {
                    if(i.iarItemId == item.iarItemId) continue;
                    i.stockItemId = null;
                    i.stockName = "";
                }
            }
        },
        dropStocks(data) {
            if (this.setAllStock) {
                this.form.forEach((item) => {
                    item.stockItemId = data.id;
                    item.stockName = `${data.stockNumber || 'Not indicated'} (${data.name})`;
                });
            }else{
                var index = this.form.findIndex((item) => item.iarItemId == this.selectedIar);
                this.form[index].stockItemId = data.id;
                this.form[index].stockName = `${data.stockNumber || 'Not indicated'} (${data.name})`;
            }
        },
        updateForm(data){
            this.isUpdate = true;
            this.form = [{
                id: data.id,
                iarItemId: data.iarItem.id,
                itemName: data.iarItem.itemName,
                description: data.iarItem.description,
                quantity: data.quantity,
                maxQuantity: data.iarItem.availableQuantity + data.quantity,
                endUserId: data.endUserId,
                employeeName: data.accountableOfficer ? data.accountableOfficer.firstName.concat(" ", data.accountableOfficer.lastName) : '',
                propertyLocationId: data.propertyLocationId,
                location: data.propertyLocation ? data.propertyLocation.location : '',
                note: data.note,
            }];
            this.currentPageForm = 1;
        },
        updateFormFromSupply(data){
            this.isUpdate = true;
            this.form = [{
                id: data.id,
                iarItemId: data.iarItemId,
                stockItemId: data.stockItemId,
                itemName: data.itemName,
                description: data.description,
                quantity: data.quantity,
                maxQuantity: data.available + data.quantity,
                endUserId: data.endUserId,
                employeeName: data.endUser,
                propertyLocationId: 0,
                location: data.propertyLocation ? data.propertyLocation.location : "",
                note: data.note,
            }]
            this.currentPageForm = 1;
        },
        getStocks(iarItemId) {
            this.selectedIar = iarItemId;
            this.$refs.stocks.getData(true);
            this.$bvModal.show("stocks-modal");
        },
        resetForm(arr) {
            this.submitted = false;
            this.form = arr.map((item) => {
                return {
                    iarItemId: item.id,
                    itemName: item.itemName,
                    description: item.description,
                    quantity: item.availableQuantity,
                    maxQuantity: item.availableQuantity,
                    endUserId: '',
                    employeeName: '',
                    propertyLocationId: this.from === 'office' ? '' : 0,
                    location: '',
                    stockItemId: item.stockItemId || 0,
                    stockName: '',
                    employeeSample: item.endUserName || 'N/A',
                    note: `PO Number: ${item.poNumber}`,
                }
            })
            this.currentPageForm = 1;
            this.isUpdate = false;
            this.generateRIS = true;
            this.requisitionNumber = '';
        },
    },
};
</script>
<template>
    <b-modal
        id="req-modal"
        :title="modalTitle"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
            <div class="d-flex justify-content-between mb-1" v-if="!isUpdate">
                <label class="font-size-15">Item {{ currentPageForm }} of {{ form ? form.length : 1 }}</label>
                <div class="dataTables_paginate paging_simple_numbers">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        style="z-index: 1000 !important"
                        v-model="currentPageForm"
                        :total-rows="form ? form.length : 1"
                        :per-page="1"
                    ></b-pagination>
                    </ul>
                </div>
            </div>
            <hr class="my-2" v-if="!isUpdate" />
            <div v-for="(item, index) in filteredForm" :key="index">
                <div class="mb-3">
                    <div class="d-flex">
                        <div class="py-2" style="min-width: 80%">
                            <div class="text-white">{{ item.itemName }}</div>
                            <small>{{ item.description }}</small>
                        </div>
                        <div class="py-2 px-2" style="min-width: 20%">
                            <div class="d-flex align-items-center">
                                <small class="mx-2">Qty:</small>
                                <div class="form-control" v-if="from === 'office'">{{ item.quantity }}</div>
                                <input
                                    id="quantity"
                                    type="number"
                                    v-model="item.quantity"
                                    placeholder="Enter Quantity..."
                                    step="any"
                                    :max="item.maxQuantity"
                                    min="1"
                                    class="form-control"
                                    autocomplete="off"
                                    v-else
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="from === 'supply' && !isUpdate">
                    <div class="mb-3">
                        <div class="form-check form-checkbox-outline form-check-success">
                            <input
                                type="checkbox"
                                id="autoGenerate"
                                checked="checked"
                                class="form-check-input"
                                v-model="generateRIS"
                            /><label for="autoGenerate" class="form-check-label">
                                Auto Generate RIS Number
                            </label>
                        </div>
                    </div>
                    <b-collapse :visible="!generateRIS">
                        <div v-if="!generateRIS" class="mb-3">
                            <label for="requisitionNumber">RIS Number </label>
                            <input
                                id="requisitionNumber"
                                type="text"
                                v-model="requisitionNumber"
                                placeholder="Enter RIS Number..."
                                class="form-control"
                                autocomplete="off"
                            />
                        </div>
                    </b-collapse>
                </template>
                <div class="mb-3" v-if="from === 'supply'">
                    <div class="mb-3">
                        <div class="form-check form-checkbox-outline form-check-success">
                            <input
                                type="checkbox"
                                id="addToStock"
                                class="form-check-input"
                                v-model="addToStock"
                            /><label for="addToStock" class="form-check-label">
                                Add to Stock Item
                            </label>
                        </div>
                    </div>
                    <b-collapse :visible="addToStock">
                        <div class="mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <label for="quantity">Stock
                                    <div
                                        v-if="form && form.length > 1"
                                        class="form-check form-checkbox-outline form-check-success"
                                    >
                                        <input
                                            type="checkbox"
                                            id="setAllLocation"
                                            class="form-check-input"
                                            @change="assignToAllStock(item, $event)"
                                            v-model="setAllStock"
                                        />
                                        <label for="setAllLocation" class="form-check-label">
                                            <small>Assign to all items</small>
                                        </label>
                                    </div>
                                </label>
                                <div class="form-check form-checkbox-outline form-check-success">
                                    <input
                                        id="autoCredit"
                                        type="checkbox"
                                        class="form-check-input"
                                        v-model="item.autoCredit"
                                    /><label for="autoCredit" class="form-check-label">
                                    Auto Credit
                                    </label>
                                </div>
                            </div>
                            
                            <b-input-group>
                                <template #append>
                                <b-button @click="getStocks(item.iarItemId)" variant="outline-info"
                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                ></b-button>
                                </template>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    disabled
                                    placeholder="Search Stock..."
                                    class="form-control"
                                    :class="{
                                        'is-invalid': submitted && addToStock && (item.stockItemId == '' || item.stockItemId == null)
                                    }"
                                    v-model="item.stockName"
                                />
                            </b-input-group>
                            <div
                                v-if="submitted && addToStock && (item.stockItemId == '' || item.stockItemId == null)"
                                class="invalid-feedback"
                            >
                                <span>This value is required.</span>
                            </div>
                        </div>
                    </b-collapse>
                </div>
                <div class="mb-3">
                    <label for="quantity">End User
                        <div v-if="form && form.length > 1" class="form-check form-checkbox-outline form-check-success">
                            <input
                                type="checkbox"
                                id="setAllEmployee"
                                class="form-check-input"
                                @change="assignToAllEmployee(item)"
                                v-model="setAllEmployee"
                            />
                            <label for="setAllEmployee" class="form-check-label"><small>Assign to all items</small></label>
                        </div>
                    </label>
                    <b-input-group>
                    <template #append>
                        <b-button
                            @click="getEmployee(item.iarItemId, item.employeeSample)"
                            variant="outline-info"
                        >
                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                        </b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Employee..."
                        class="form-control"
                        :class="{'is-invalid': submitted && (item.endUserId == '' || item.endUserId == null)}"
                        v-model="item.employeeName"
                    />
                    </b-input-group>
                    <div
                        v-if="submitted && (item.endUserId == '' || item.endUserId == null)"
                        class="invalid-feedback"
                    >
                        <span>This value is required.</span>
                    </div>
                    <small v-if="(!submitted || item.endUserId !== '') && from === 'supply' && !isUpdate" class="text-info ms-1">PO User: {{ item.employeeSample }}</small>
                </div>
                <div class="mb-3" v-if="from === 'office'">
                    <label for="quantity">Location
                    <div
                        v-if="form && form.length > 1"
                        class="form-check form-checkbox-outline form-check-success"
                    >
                        <input
                            type="checkbox"
                            id="setAllLocation"
                            class="form-check-input"
                            @change="assignToAllLocation(item, $event)"
                            v-model="setAllLocation"
                        />
                        <label for="setAllLocation" class="form-check-label">
                            <small>Assign to all items</small>
                        </label>
                    </div>
                    </label>
                    <b-input-group>
                    <template #append>
                        <b-button
                            @click="getLocation(item.iarItemId)"
                            variant="outline-info"
                        >
                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                        </b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Location..."
                        class="form-control"
                        :class="{'is-invalid': submitted && (item.propertyLocationId == '' || item.propertyLocationId == null)}"
                        v-model="item.location"
                    />
                    </b-input-group>
                    <div
                        v-if="submitted && (item.propertyLocationId == '' || item.propertyLocationId == null)"
                        class="invalid-feedback"
                    >
                    <span>This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="note">Note</label>
                    <textarea
                        id="note"
                        rows="4"
                        v-model="item.note"
                        placeholder="Enter Notes..."
                        class="form-control"
                        autocomplete="off"
                    ></textarea>
                </div>
            </div>
            <hr class="my-2" />
            <div class="d-flex flex-row-reverse mt-3">
                <button type="submit" class="btn btn-primary">
                    {{ buttonText }}
                </button>
            </div>
        </form>
        <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
        <Location ref="location" @dropData="dropLocation($event)"></Location>
        <Stocks ref="stocks" @dropData="dropStocks($event)"></Stocks>
    </b-modal>
</template>